import { render } from "./door-sales-recent-sales.vue?vue&type=template&id=21421aa1&scoped=true"
import script from "./door-sales-recent-sales.vue?vue&type=script&lang=js"
export * from "./door-sales-recent-sales.vue?vue&type=script&lang=js"

import "./door-sales-recent-sales.vue?vue&type=style&index=0&id=21421aa1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21421aa1"]])

export default __exports__